import React, { useMemo, useRef } from "react";
import JoditEditor from "jodit-react";

const baseUrl = process.env.REACT_APP_SERVER_URL || "";

interface QuillEditorProps {
  value: string;
  onChange: (value: string) => void;
  path?: string;
}

const QuillEditor: React.FC<QuillEditorProps> = ({ value, onChange }) => {
  const editorRef = useRef(null);

  const config = useMemo(
    () => ({
      readonly: false,
      placeholder: "Rédigez votre description ici...",
      height: 400,
      language: "fr",
      toolbarAdaptive: false,
      buttons: [
        "bold",
        "italic",
        "underline",
        "strikethrough",
        "|",
        "ul",
        "ol",
        "|",
        "outdent",
        "indent",
        "|",
        "font",
        "fontsize",
        "brush",
        "paragraph",
        "|",
        "image",
        "video",
        "table",
        "link",
        "|",
        "align",
        "|",
        "undo",
        "redo",
        "|",
        "hr",
        "eraser",
        "copyformat",
        "|",
        "fullsize",
        "source",
      ],
      showCharsCounter: false,
      showWordsCounter: false,
      showXPathInStatusbar: false,
      askBeforePasteHTML: false,
      askBeforePasteFromWord: false,
      defaultActionOnPaste: "insert_clear_html" as const,
      // Upload images to the server to avoid blob: / base64 URLs in the description
      uploader: {
        url: `${baseUrl}/api/news/upload-image`,
        insertImageAsBase64URI: false,
        imagesExtensions: ["jpg", "jpeg", "png", "gif", "webp"],
        filesVariableName: () => "image",
        isSuccess: (resp: any) => !!resp.url,
        getMessage: (resp: any) => resp.message || "",
        process: (resp: any) => ({
          files: [resp.url],
          path: "",
          baseurl: baseUrl,
          error: resp.error ? 1 : 0,
          message: resp.message || "",
        }),
        defaultHandlerSuccess: function (this: any, data: any) {
          const files: string[] = data.files || [];
          files.forEach((url: string) => {
            const fullUrl = url.startsWith("http") ? url : `${baseUrl}${url}`;
            this.j.selection.insertHTML(
              `<img src="${fullUrl}" style="max-width:100%;" />`
            );
          });
        },
      },
    }),
    []
  );

  return (
    <JoditEditor
      ref={editorRef}
      value={value}
      config={config}
      onBlur={(newContent: string) => onChange(newContent)}
      onChange={() => {}}
    />
  );
};

export default QuillEditor;
